import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";
import { STORE_CONFIG } from "../config/store";

function PolicyLayout({ title, intro, children }) {
  const toneIndex = [...title].reduce((sum, character) => sum + character.charCodeAt(0), 0) % 5;
  const accents = ["#6a3274", "#d6554d", "#177d78", "#b46a12", "#4056a1"];
  return (
    <div className={`policy-page policy-tone-${toneIndex}`} style={{ "--policy-accent": accents[toneIndex] }}>
      <div className="breadcrumb"><Link to="/">Home</Link> &gt; <span>{title}</span></div>
      <main id="MainContent" className="policy-main">
        <article className="policy-card">
          <p className="policy-kicker">{STORE_CONFIG.brand} · {STORE_CONFIG.operatingRegion}</p>
          <h1 className="giant-title">{title}</h1>
          <p className="policy-updated">Effective {STORE_CONFIG.policyEffectiveDate} · Times are interpreted in {STORE_CONFIG.timeZone}.</p>
          {intro && <p className="policy-intro">{intro}</p>}
          <div className="policy-content">{children}</div>
          <section className="policy-rights">
            <h2>Mandatory rights</h2>
            <p>Nothing in this policy removes a consumer, privacy or other remedy that cannot lawfully be excluded from the relevant purchase, request or use of the storefront.</p>
          </section>
          <section className="policy-contact">
            <h2>Contact</h2>
            <p>Questions or requests about this policy can be sent to <a href={`mailto:${STORE_CONFIG.supportEmail}`}>{STORE_CONFIG.supportEmail}</a>. Include an order number where relevant, but never send payment-card details by email.</p>
            <p><Link to="/policies">Browse the complete policy directory</Link>.</p>
          </section>
        </article>
      </main>
    </div>
  );
}

export default PolicyLayout;
